import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
} from '@angular/core';
import { ViewerAsset } from '@models/viewer-asset';
import { ZbpIconComponent } from '@shared/zbp-icon/zbp-icon';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';

/**
 * Displays additional information included on the Content Sheet for Viewer Assets using innerHTML.
 *
 * Will not display the section if Content Sheet doesn't have any additional info provided for the Asset.
 *
 * Displayed content is readonly.
 */
@Component({
  selector: 'zbp-viewer-additional-info',
  templateUrl: './viewer-additional-info.component.html',
  styleUrls: ['./viewer-additional-info.component.scss',],
  imports: [
    CommonModule,
    ZbpIconComponent,
  ]
})
export class ViewerAdditionalInfoComponent {
  @Input() asset: ViewerAsset;

  isOpen: boolean = false;

  readonly iconNames = zbpIconNames;

  toggleContainerOpen() {
    this.isOpen = !this.isOpen;
  }
}
